
import microuniversoApi from "app/api/microuniversoApi";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { HistoricoOrcamento } from "./HistoricoOrcamento";
import { DadoHistoricoOrcamento } from "app/types/pesquisa-orcamento/consultas/Historico";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { useMenuConsultasPesquisaOrcamento } from "../menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";
import { Parametro } from "app/types/Parametro";
import { obterParametros } from "app/use-cases/parametro/obterParametros";

const parametrosHistoricoOrcamento = [
    "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA",
];

export type HistoricoOrcamentoContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
};

export const HistoricoOrcamentoContainer = (props: HistoricoOrcamentoContainerProps) => {

    const [dados, setDados] = useState<Partial<PagedMessageResponse<DadoHistoricoOrcamento>>>({});
    const [parametros, setParametros] = useState<Parametro[]>([]) // 487678

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    const isMounted = useRef<boolean>(true);
    const ultimaRequisicaoHistorico = useRef<number>(0);

    const passosMenu = useMemo(() => new Dict<string, () => void>(Object.assign({}, props.passos.map)), [props.passos]);

    const atualizarParametros = useCallback(async () => {// 487678
        try {
            const parametrosAtualizados = await obterParametros({
                nomes: parametrosHistoricoOrcamento,
            });

            if (!isMounted.current) return;

            setParametros(parametrosAtualizados)
        }
        catch (e) {
            if (isMounted.current) tratamentoErroPadrao(e);
        }
    }, [])
    
        
    const onVoltar = useCallback(() => {
        props.onRemover?.()
        props.onVoltar()
    }, [props.onRemover, props.onVoltar])

    const onObterDadosHistorico = useCallback(async (pagina?: number) => {
        const numeroRequisicao = ++ultimaRequisicaoHistorico.current;

        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.DadosHistoricoOrcamento(
                props.orcamentoSelecionado.NumeroPedido, pagina ?? 1
            );

            if (!isMounted.current || numeroRequisicao !== ultimaRequisicaoHistorico.current) return;

            if (!resultado || ("Error" in resultado)) {
                onVoltar();
                return
            }

            setDados(resultado);
        }
        catch (e) {
            if (isMounted.current && numeroRequisicao === ultimaRequisicaoHistorico.current) {
                tratamentoErroPadrao(e);
            }
        }
        finally {
            globalMU.unblockUI();
        }
    }, [props.orcamentoSelecionado.NumeroPedido, onVoltar])

    const onPassoSelecionado = useCallback((passo: string) => {
        props.onRemover?.()
        passosInterno.current.get(passo)?.()
    }, [props.onRemover])

    useMenuConsultasPesquisaOrcamento({
        onVoltar: props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: passosMenu,
    })

    useEffect(() => {
        isMounted.current = true;
        passosInterno.current.set("Histórico", () => { })
        atualizarParametros() // 487678
        onObterDadosHistorico();

        return () => {
            isMounted.current = false;
            ultimaRequisicaoHistorico.current += 1;
        }
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="HistoricoOrcamentoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />


            <HistoricoOrcamento
                orcamentoSelecionado={props.orcamentoSelecionado}
                parametros={parametros} // 487678
                historicos={dados}
                onPesquisarPaginado={onObterDadosHistorico}
            />
        </>
    )
}
